module.exports = "https://cdn.realtymogul.com/static/media/loader-black.9718bedc.svg";